export const COMPANY_URL = 'https://www.cidemipymes.com.mx/v1/company';

export const IMAGE_PREFIX_URL = 'https://www.cidemipymes.com.mx/logos/';

export const REQUEST_HEADERS = {
    "x-api-key": 'uIFXa5UHUW11VV3mYecGI971C9FiMP0gE2HbEwq7',
    "Accept-Encoding": "gzip"
}

export const PAGE_SIZE = 5;

export const CIRCLE_COLORS =  {
    orderPrimary: '#41A5E7',
    orderSecondary: '#E1F3FF',
    orderHoverPrimary: '#3785B9',
    controlPrimary: '#EABF00',
    controlSecondary: '#F5F8DF',
    controlHoverSecondary: '#BD9E13',
    qualityPrimary: '#00D4A8',
    qualitySecondary: '#DDFFF8',
    qualityHoverPrimary: '#068D71',
    leadershipPrimary: '#2B6AA3',
    leadershipHoverPrimary: '#1D4870',
    leadershipSecondary: '#E8EBFF',
    disabled: '#F1F8FF',
    border: '#FFFFFF',
    hoverSecondary: '#EDEEEF'
}

export const AUTH0_REDIRECT_URL = window.location.origin + "/company/";